import { Alert, LoadingOverlay } from '@mantine/core';
import { MantineForm, SaveStatus } from '../AddEditMatterForm';
import { CircleAlertIcon } from 'lucide-react';
import { FlattenedMatter } from '@/database/aggregateTypes';
import styles from './AddEditMatterFormFooter.module.css';

const AddEditMatterFormFooter = ({
  matter,
  saveStatus,
  mantineForm,
  onClose,
}: {
  matter: FlattenedMatter | undefined;
  saveStatus: SaveStatus | undefined;
  mantineForm: MantineForm;
  onClose: () => void;
}) => {
  return (
    <section className={styles.formFooter}>
      {saveStatus?.status === 'error' ? (
        <Alert color='red' icon={<CircleAlertIcon />}>
          {saveStatus.message}
        </Alert>
      ) : Object.keys(mantineForm.errors).length > 0 ? (
        <Alert color='red' icon={<CircleAlertIcon />}>
          {Object.entries(mantineForm.errors).map(([key, value]) => (
            <div key={key}>
              {key}: {value}
            </div>
          ))}
        </Alert>
      ) : null}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: '10px',
        }}
      >
        <button
          className='primary-button'
          style={{ position: 'relative' }}
          type='submit'
          disabled={saveStatus?.status === 'loading'}
        >
          {matter ? 'Save Changes' : 'Save'}
          <LoadingOverlay
            loaderProps={{ color: '#ff00bf', size: 'sm' }}
            overlayProps={{ backgroundOpacity: 0 }}
            visible={saveStatus?.status === 'loading'}
          />
        </button>
        <button
          type='button'
          disabled={saveStatus?.status === 'loading'}
          className='outline-button'
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
    </section>
  );
};

export default AddEditMatterFormFooter;
